import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation } from 'react-router-dom';
import settings from '../utilities/settings';

/**
 * Componente che gestisce il pre-login da altri siti (es. assobay)
 * Quando assobay chiama exchange con un token, questo componente
 * fa il silent sign-in per preparare la sessione
 * 
 * Uso: https://exchangestaging.plurima.uk?prelogin_token=TOKEN
 */
export default function AuthPreLogin() {
    const auth = useAuth();
    const location = useLocation();
    
    // Estrai il token dalla query string
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('prelogin_token');

    useEffect(() => {
        // Se c'è un token di pre-login, verificalo e fai silent sign-in
        if (token && !auth.isAuthenticated && !auth.isLoading) {
            // Verifica il token chiamando il backend
            fetch(`${settings.Domains.ServiceApi}/api/auth/prelogin?token=${encodeURIComponent(token)}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(async (response) => {
                    if (response.ok) {
                        // Token valido, fai silent sign-in
                        console.log("Token pre-login valido, tentativo silent sign-in...");
                        try {
                            await auth.signinSilent();
                            console.log("Pre-login completato con successo");
                            // Rimuovi il token dalla URL
                            window.history.replaceState({}, '', window.location.pathname);
                        } catch (error) {
                            console.log("Silent sign-in fallito:", error);
                        }
                    } else {
                        console.log("Token pre-login non valido");
                    }
                })
                .catch((error) => {
                    console.error("Errore nella verifica del token:", error);
                });
        }
    }, [token, auth.isAuthenticated, auth.isLoading, auth.signinSilent]);

    return null;
}

